module.exports = __webpack_public_path__ + "static/media/presentation_4.d2cc5762.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/neonat/icons/presentation_4.svg
// module id = 632
// module chunks = 1